import { urls } from "../../shared/seo/links";

export const COURTS = ["cassation", "appel", "premiere"];

// ONAT only publishes Arabic names: fall back to it in French and English.
export function lawyerName(lawyer, lang) {
  return urls.lawyerName(lawyer || {}, lang);
}

/** The lawyer's governorate (geo.js entry), from its key or any stored spelling. */
export function lawyerGovernorate(lawyer) {
  return (
    urls.findGovernorate(lawyer.governorateKey) ||
    urls.findGovernorate(lawyer.stateInFrench) ||
    urls.findGovernorate(lawyer.stateInArabic)
  );
}

export function lawyerState(lawyer, lang) {
  const gov = lawyerGovernorate(lawyer);
  if (gov) return urls.governorateName(gov, lang);
  return lang == "ar" ? lawyer.stateInArabic : lawyer.stateInFrench;
}

export function lawyerAddress(lawyer, lang) {
  return (lang == "ar" ? lawyer.addressInArabic : lawyer.addressInFrench) ||
    lawyer.addressInArabic || lawyer.addressInFrench || "";
}

// Lawyers imported from the ONAT roll have no account: no online booking.
// The directory omits "verified", so only an explicit false counts.
export function takesOnlineBooking(lawyer) {
  return lawyer.source !== "onat" && Boolean(lawyer.subscribed) && lawyer.verified !== false;
}

export function hasProfilePhoto(lawyer) {
  // "avatar.png" is the model default: no photo, show the initials.
  return Boolean(lawyer.profilePicture) && !/(^|\/)avatar\.png$/.test(lawyer.profilePicture);
}

// Two initials for the placeholder avatar ("اسامة الشابي" -> "اش"),
// ignoring the Arabic article "ال" so it doesn't give "ا" every time.
export function initials(name) {
  const words = (name || "").trim().split(/\s+/).filter(Boolean);
  const first = (word) => (word || "").replace(/^ال/, "").charAt(0);
  if (words.length === 0) return "";
  return words.length === 1
    ? first(words[0])
    : first(words[0]) + "‌" + first(words[words.length - 1]);
}

// Decoded paths: give them to navigate()/<Link to>, or toHref() for href.
// state: a governorate in any spelling (or its geo.js entry); barLevel: 1-3.
export function lawyersListUrl(lang, state, barLevel, page) {
  return urls.lawyersPath(lang, { governorate: state || undefined, barLevel, page });
}

export function lawyerProfileUrl(lawyer, lang) {
  return urls.lawyerPath(lawyer, lang);
}

// Tunisian numbers have 8 digits: show them as "50 135 944" and call +216.
export function formatPhone(phone) {
  const digits = String(phone || "").replace(/\D/g, "");
  if (!digits || /^0+$/.test(digits)) return null;
  const display =
    digits.length === 8 ? digits.replace(/(\d{2})(\d{3})(\d{3})/, "$1 $2 $3") : String(phone);
  const href = "tel:" + (digits.length === 8 ? "+216" + digits : digits);
  return { display, href };
}
